import Icon1 from "@assets/icons/Icon";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { colors } from "sexy";

interface BaseNotifModalProps {
  children: React.ReactNode;
  onClose: () => void;
  visible?: boolean;
  title?: string;
  startIcon?: React.ReactNode;
  position?: "center" | "right" | "left";
}

export default function BaseNotifModal({
  children,
  onClose,
  visible = true,
  position = "center",
}: BaseNotifModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);

  // Handle escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && visible) {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [visible, onClose]);

  if (!visible) return null;

  const positionClasses = {
    center: "items-center",
    right: "items-end pr-10",
    left: "items-start pl-10",
  };

  const modalContent = (
    <div
      className={`
        fixed inset-0 z-50 flex flex-col justify-end pb-10 pointer-events-none
        ${positionClasses[position]}
      `}
    >
      {/* Modal content */}
      <div
        ref={modalRef}
        className="bg-wshadow_50 backdrop-blur-sm  text-neutral-600 text-h3 border-neutral-300 rounded-2xl w-fit py-3 px-6 shadow-lg shadow-neutral-300 pointer-events-none"
      >
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}
